"use client";

import { useTranslations } from "next-intl";

const ROW_KEYS = [
	"comparisonRow1",
	"comparisonRow2",
	"comparisonRow3",
	"comparisonRow4",
	"comparisonRow5",
	"comparisonRow6",
	"comparisonRow7",
	"comparisonRow8",
] as const;

export default function VacuumCastingComparison() {
	const t = useTranslations("new-vacuum-casting");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						{t("comparisonTitle")}
					</h2>
					<p className="mt-3 text-sm leading-relaxed text-black sm:mt-4 md:text-base">
						{t("comparisonDesc")}
					</p>
				</header>

				<div className="overflow-x-auto">
					<table className="w-full min-w-[760px] border-collapse">
						<thead>
							<tr className="border-b border-[#d8d8c8]">
								<th className="w-[18%] py-4 pl-8 pr-4 text-left text-sm font-bold text-black md:py-5 md:text-base">
									{t("comparisonColCriteria")}
								</th>
								<th className="w-[27%] py-4 pl-4 pr-4 text-left text-sm font-bold text-black md:py-5 md:text-base">
									{t("comparisonCol3dPrinting")}
								</th>
								<th className="w-[27%] py-4 pl-4 pr-4 text-left text-sm font-bold text-black md:py-5 md:text-base">
									{t("comparisonColVacuumCasting")}
								</th>
								<th className="w-[28%] py-4 pl-4 text-left text-sm font-bold text-black md:py-5 md:text-base">
									{t("comparisonColInjectionMolding")}
								</th>
							</tr>
						</thead>
						<tbody>
							{ROW_KEYS.map((rowKey) => (
								<tr key={rowKey} className="border-b border-[#d8d8c8]">
									<td className="py-4 pl-8 pr-4 align-top text-sm font-bold text-black md:py-5 md:text-base">
										{t(`${rowKey}Label`)}
									</td>
									<td className="py-4 pl-4 pr-4 align-top text-sm leading-relaxed text-black md:py-5 md:text-base">
										{t(`${rowKey}Printing`)}
									</td>
									<td className="py-4 pl-4 pr-4 align-top text-sm leading-relaxed text-black md:py-5 md:text-base">
										{t(`${rowKey}Vacuum`)}
									</td>
									<td className="py-4 pl-4 align-top text-sm leading-relaxed text-black md:py-5 md:text-base">
										{t(`${rowKey}Injection`)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
